import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

Vue.use(VueQuillEditor)
Vue.use(ElementUI)
Vue.config.productionTip = false

// 统一读取当前登录凭证，优先取持久登录，其次取会话登录。
function getStorageItem(key) {
  return localStorage.getItem(key) || sessionStorage.getItem(key) || ''
}

// 清理所有登录相关本地存储信息。
function clearAuthStorage() {
  ;['token', 'refreshToken', 'userId', 'role', 'rememberLogin'].forEach((key) => {
    localStorage.removeItem(key)
    sessionStorage.removeItem(key)
  })
}

// 统一处理登录过期，避免多个请求重复弹窗。
let isHandlingAuthExpired = false
function handleAuthExpired(message) {
  if (isHandlingAuthExpired) return
  isHandlingAuthExpired = true
  clearAuthStorage()
  const loginMessage = message || '登录已过期，请重新登录后继续操作'

  // 如果当前请求发生在 iframe 页面中，需要让最外层页面整体跳回登录页。
  if (window.top !== window.self) {
    try {
      window.top.location.href = '/login'
    } catch (error) {
      window.location.href = '/login'
    }
  } else if (router.currentRoute.path !== '/login') {
    Vue.prototype.$message.warning(loginMessage)
    router.push('/login')
  }

  setTimeout(() => {
    isHandlingAuthExpired = false
  }, 500)
}

Vue.prototype.$http = axios
Vue.prototype.$config = window.AppConfig || {}
Vue.prototype.$auth = {
  getStorageItem,
  clearAuthStorage
}

axios.interceptors.request.use(
  // 统一为所有请求补充登录令牌。
  function (config) {
    config.headers.Authorization = getStorageItem('token')
    return config
  },
  // 请求发送前发生异常时，继续向下抛出错误。
  function (error) {
    return Promise.reject(error)
  }
)

axios.interceptors.response.use(
  // 请求成功时直接返回响应结果。
  function (response) {
    // 部分后端异常会被包装成 200 + 业务失败码，这里一并识别登录失效。
    const data = response && response.data
    const message = data && data.message ? String(data.message) : ''
    const authExpiredMessages = ['未登录', 'token无效', 'token已过期', 'Token已过期', '未能读取到有效Token', '登录已过期']
    if (data && data.code !== 0 && authExpiredMessages.some((item) => message.includes(item))) {
      handleAuthExpired('登录已过期，请重新登录后继续操作')
    }
    return response
  },
  // 遇到未登录或登录失效时，给出友好提示并跳转登录页。
  function (error) {
    if (error.response && error.response.status === 401) {
      handleAuthExpired(error.response?.data?.message || '登录已过期，请重新登录后继续操作')
      return new Promise(() => {})
    }
    return Promise.reject(error)
  }
)

new Vue({
  router: router,
  // 挂载应用根组件。
  render: function (h) {
    return h(App)
  }
}).$mount('#app')
